import { render, staticRenderFns } from "./myInviter.vue?vue&type=template&id=46501954&scoped=true&"
import script from "./myInviter.vue?vue&type=script&lang=js&"
export * from "./myInviter.vue?vue&type=script&lang=js&"
import style0 from "./myInviter.vue?vue&type=style&index=0&id=46501954&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46501954",
  null
  
)

export default component.exports